<template>
  <div class="page-features-card">
    <h3 class="page-features-card__title">{{ title }}</h3>
    <p class="page-features-card__text">{{ text }}</p>
    <div class="page-features-card__image-container">
      <video
        class="page-features-card__video" :poster="image" preload="auto" muted autoplay loop data-keepplaying
        playsinline webkit-playsinline
      >
        <source :src="video" type="video/mp4">
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageFeaturesCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    video: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/page-features-card";
</style>